import component from "./TimePrice";
export default component;
